import { useAppSelector } from "app/hooks";

const UserFullName = ({
  id,
  showCredentials,
}: {
  id: number | null | undefined;
  showCredentials?: boolean;
}) => {
  const user = useAppSelector((state) => state.users[id || 0]);
  if (!id || !user) return null;

  const { first_name, last_name, userprofile } = user;

  return (
    <>
      {[first_name, last_name].filter((s) => !!s).join(" ")}
      {showCredentials && userprofile?.credentials && (
        <>, {userprofile?.credentials}</>
      )}
    </>
  );
};

export default UserFullName;
